import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { ContactPage } from './pages/ContactPage';
import { useAnalytics } from './hooks/useAnalytics';
// Declare rdt, fbq, and ttq functions for TypeScript
declare global {
  interface Window {
    rdt: (action: string, ...args: any[]) => void;
    fbq: (action: string, ...args: any[]) => void;
    ttq: {
      page: () => void;
      track: (event: string, params?: any) => void;
    };
  }
}
function AppContent() {
  const location = useLocation();
  const {
    trackPageView
  } = useAnalytics();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
    // Track Reddit Pixel page visit on route changes
    if (window.rdt) {
      window.rdt('track', 'PageVisit');
    }
    // Track Meta Pixel page view on route changes
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
    // Track TikTok Pixel page view on route changes
    if (window.ttq) {
      window.ttq.page();
    }
  }, [location, trackPageView]);
  return <div className="flex flex-col min-h-screen w-full" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/contact" element={<ContactPage data-id="element-7" />} data-id="element-6" />
        </Routes>
      </main>
      <Footer data-id="element-8" />
    </div>;
}
export function App() {
  // Initialize Reddit Pixel, Meta Pixel, and TikTok Pixel on mount
  useEffect(() => {
    // Reddit Pixel initialization script
    !function (w, d) {
      if (!w.rdt) {
        var p = w.rdt = function () {
          p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments);
        };
        p.callQueue = [];
        var t = d.createElement('script');
        t.src = 'https://www.redditstatic.com/ads/pixel.js', t.async = !0;
        var s = d.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(t, s);
      }
    }(window, document);
    // Initialize Reddit Pixel with account ID
    window.rdt('init', 'a2_i06tz4o5tyzi');
    window.rdt('track', 'PageVisit');
    // Meta Pixel initialization script
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize Meta Pixel with ID
    window.fbq('init', '1342283050720309');
    window.fbq('track', 'PageView');
    // TikTok Pixel initialization script
    !function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      var ttq = w[t] = w[t] || [];
      ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'], ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) {
        for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e;
      }, ttq.load = function (e, n) {
        var i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date(), ttq._o = ttq._o || {}, ttq._o[e] = n || {};
        var o = document.createElement('script');
        o.type = 'text/javascript', o.async = !0, o.src = i + '?sdkid=' + e + '&lib=' + t;
        var a = document.getElementsByTagName('script')[0];
        a.parentNode.insertBefore(o, a);
      };
      // Initialize TikTok Pixel with ID
      ttq.load('D4S3S7BC77U23H9UKQS0');
      ttq.page();
    }(window, document, 'ttq');
  }, []);
  return <BrowserRouter data-id="element-9">
      <AppContent data-id="element-10" />
    </BrowserRouter>;
}